<div class="modal-historico">
  <h2 mat-dialog-title>Histórico de Geografías</h2>
  
  <mat-dialog-content>
    <div *ngIf="historico.length === 0" class="text-center p-3">
      No hay registros de histórico para este polígono.
    </div>
    
    <div *ngIf="historico.length > 0" class="table-container">
      <table mat-table [dataSource]="historico" class="w-100">
        
        <ng-container matColumnDef="FECHA_EVENTO">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let element">{{element.FECHA_EVENTO | date:'dd/MM/yyyy HH:mm'}}</td>
        </ng-container>

        <ng-container matColumnDef="USUARIO_EVENTO">
          <th mat-header-cell *matHeaderCellDef>Usuario</th>
          <td mat-cell *matCellDef="let element">{{element.USUARIO_EVENTO}}</td>
        </ng-container>

        <ng-container matColumnDef="ACCION">
          <th mat-header-cell *matHeaderCellDef>Acción</th>
          <td mat-cell *matCellDef="let element">
            <span class="badge" [ngClass]="{'badge-success': element.ACCION === 'INSERT', 'badge-warning': element.ACCION === 'UPDATE', 'badge-danger': element.ACCION === 'DELETE'}">
              {{element.ACCION}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="DEPARTAMENTO">
          <th mat-header-cell *matHeaderCellDef>Departamento</th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.COD_DPTO_OLD !== element.COD_DPTO_NEW">
              <small class="cambio-old">{{element.COD_DPTO_OLD || 'N/A'}}</small>
              <mat-icon class="arrow-icon">arrow_forward</mat-icon>
              <small class="cambio-new">{{element.COD_DPTO_NEW || 'N/A'}}</small>
            </div>
            <small *ngIf="element.COD_DPTO_OLD === element.COD_DPTO_NEW">{{element.COD_DPTO_NEW || 'Sin cambios'}}</small>
          </td>
        </ng-container>

        <ng-container matColumnDef="MUNICIPIO">
          <th mat-header-cell *matHeaderCellDef>Municipio</th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.COD_MNPO_OLD !== element.COD_MNPO_NEW">
              <small class="cambio-old">{{element.COD_MNPO_OLD || 'N/A'}}</small>
              <mat-icon class="arrow-icon">arrow_forward</mat-icon>
              <small class="cambio-new">{{element.COD_MNPO_NEW || 'N/A'}}</small>
            </div>
            <small *ngIf="element.COD_MNPO_OLD === element.COD_MNPO_NEW">{{element.COD_MNPO_NEW || 'Sin cambios'}}</small>
          </td>
        </ng-container>

        <ng-container matColumnDef="ZONA">
          <th mat-header-cell *matHeaderCellDef>Zona</th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.COD_ZONA_LOG_OLD !== element.COD_ZONA_LOG_NEW">
              <small class="cambio-old">{{element.COD_ZONA_LOG_OLD || 'N/A'}}</small>
              <mat-icon class="arrow-icon">arrow_forward</mat-icon>
              <small class="cambio-new">{{element.COD_ZONA_LOG_NEW || 'N/A'}}</small>
            </div>
            <small *ngIf="element.COD_ZONA_LOG_OLD === element.COD_ZONA_LOG_NEW">{{element.COD_ZONA_LOG_NEW || 'Sin cambios'}}</small>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="cerrar()">Cerrar</button>
  </mat-dialog-actions>
</div>
